import { useCredentialsExpiringSoonCountRetrieveQuery } from '../external/bambi-api/bambiApi';
import { useUserRoles } from 'src/features/auth/useUserRoles';

export default function useCredentialsExpiringSoonCount() {
  const { isRideOrderingPortalUser } = useUserRoles();

  const { data: expiredMemberCredentialsCount } =
    useCredentialsExpiringSoonCountRetrieveQuery(undefined, {
      skip: isRideOrderingPortalUser,
    });

  return expiredMemberCredentialsCount;
}
